export const patternDecoders: Map<RegExp, (match: RegExpMatchArray, options?: any) => string | preact.VNode> =
  new Map();

export const registerPatternDecoder = (
  pattern: RegExp,
  decoder: (match: RegExpMatchArray, options?: any) => string | preact.VNode
) => {
  patternDecoders.set(pattern, decoder);
};
